enum BonusProvider {
    Betler = 'Betler',
    Comtrade = 'Comtrade',
}

export default BonusProvider;
